import { CacheKey } from "../types/cache-keys";
import { Opportunity } from "../types/opportunity";
import { SalesforceTaskResponse, SfActivityTask, SfRecordType } from "../types/salesforce";
import { checkAndTagSE } from "./opportunityHelpers";
import { patchItem, postItem } from "./queries";
import { queryClient } from "./queryClient";
import { store } from "./store";

export interface CreateSEActivityArgs {
  summary: string;
  details: string;
  serviceType?: string | null;
  technology?: string;
  dueDate?: string;
}

export const createSEActivity = async (
  resourceType: SfRecordType,
  resourceId: string,
  args: CreateSEActivityArgs
): Promise<SalesforceTaskResponse> => {
  const { summary, details, serviceType = null, technology, dueDate } = args;
  const state = store.getState();
  const sfId = state.user.userData.sfId;

  const resourceTypeKey = {
    [SfRecordType.Opportunity]: CacheKey.OpportunityActivityHistory,
    [SfRecordType.Customer]: CacheKey.CustomerActivityHistory
  }

  const currentDate = (() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  })();

  const activityDate = dueDate ?? currentDate;

  const seActivity: SfActivityTask = {
    RecordTypeId: '0124x000000QgjNAAS',
    WhatId: resourceId,
    Subject: summary,
    Status: 'Completed',
    Priority: 'Normal',
    OwnerId: sfId,
    Description: details,
    Demo_Trial_Resource__c: 'SE - Security',
    TaskSubtype: 'Task',
    SE_Service_Type__c: serviceType,
    Technology__c: technology ?? 'N/A',
    Business_Entity_Type__c: 'Security',
    Security_Concierge__c: false,
    ActivityDate: activityDate,
    ReminderDateTime: `${activityDate}T20:00:00.000+0000`
  }

  try {
    const response = await postItem('sf/sobject/Task', seActivity);
    queryClient.invalidateQueries({ queryKey: [resourceTypeKey[resourceType], String(resourceId)] });
    return response as SalesforceTaskResponse;
  } catch (error) {
    console.error('Error adding SE Activity:', error);
    throw error;
  }
};

export const updateSENote = async (opportunity: Opportunity, note: string) => {
  await checkAndTagSE(opportunity);
  const updatedOpportunity = {
    Id: opportunity.id || opportunity.Id,
    SE_Notes_New__c: note,
  }

  try {
    await patchItem('sf/opportunity', updatedOpportunity);
    queryClient.invalidateQueries({ queryKey: [CacheKey.Opportunity, opportunity.id ?? opportunity.Id] });
  } catch (error) {
    console.error('Error adding SE Note:', error);
  }
};